import 'lazysizes';
import objectFitImages from 'object-fit-images';
objectFitImages();

//////////////////////////////
// グローバル変数
//////////////////////////////
window.gSTRG = [];
window.gSTRG.rootHTML = document.documentElement;
window.gSTRG.lang = window.gSTRG.rootHTML.lang;
window.gSTRG.mods = [];
window.gSTRG.isDevice = '';
window.gSTRG.isAndroid = false;
window.gSTRG.isEnableTouch = false;

const ua = navigator.userAgent.toLowerCase();
if (/iphone|ipad|macintosh|ipod/.test(ua) && 'ontouchend' in document) {
  gSTRG.rootHTML.classList.add('strg-mobile');
  gSTRG.isDevice = 'mobile';
  gSTRG.isAndroid = false;
} else if (/android/.test(ua) && 'ontouchend' in document) {
  gSTRG.rootHTML.classList.add('strg-mobile');
  gSTRG.isDevice = 'mobile';
  gSTRG.isAndroid = true;
} else {
  gSTRG.rootHTML.classList.add('strg-pc');
  gSTRG.isDevice = 'pc';
  gSTRG.isAndroid = false;
}

if(window.ontouchstart !== undefined && 0 < navigator.maxTouchPoints) {
  gSTRG.isEnableTouch = true;
}

//history.scrollRestoration = 'manual';

window.delay = (n) => {
  n = n || 2000;
  return new Promise((done) => {
    setTimeout(() => {
      done();
    }, n);
  });
};
